import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import UFOSegment from "@atlassian/wac-ufo-segment";

import { useLocalizedHref } from "@/libraries/web-framework";
import { Logo } from "@/libraries/wpl/foundations/src";
import { ProductPageSubNav } from "@/patterns/global-nav/src";

type EnterprisePageProductNavProps = {
    readonly isActive?: "overview" | "services" | "resources";
};

export const EnterprisePageProductNav = ({
    isActive
}: EnterprisePageProductNavProps) => {
    const intl = useIntl();

    const ctaButtonText = intl.formatMessage({
        id: "EnterpriseLandingPage.navbar.cta",
        defaultMessage: "Contact sales"
    });

    const mobileCtaButtonText = intl.formatMessage({
        id: "EnterpriseLandingPage.navbar.mobile.cta",
        defaultMessage: "Contact sales"
    });
    const links = [
        {
            globalLinksKey: "overview",
            linkText: intl.formatMessage({
                id: "EnterpriseLandingPage.navbar.overview",
                defaultMessage: "Overview"
            }),
            hasSubnav: false,
            isActive: isActive == "overview",
            productKey: "enterprise",
            href: useLocalizedHref("/enterprise")
        },
        {
            globalLinksKey: "services",
            linkText: intl.formatMessage({
                id: "EnterpriseLandingPage.navbar.services",
                defaultMessage: "Services"
            }),
            hasSubnav: false,
            isActive: isActive == "services",
            productKey: "enterprise",
            href: useLocalizedHref("/enterprise/services")
        },
        {
            globalLinksKey: "resources",
            linkText: intl.formatMessage({
                id: "EnterpriseLandingPage.navbar.resources",
                defaultMessage: "Resources"
            }),
            hasSubnav: false,
            isActive: isActive == "resources",
            productKey: "enterprise",
            href: useLocalizedHref("/enterprise/resources")
        }
    ];

    const logoWrapperStyles = css({
        height: "28px"
    });
    const EnterpriseLogo = () => (
        <div css={logoWrapperStyles}>
            <Logo brand="enterprise" type="logo" appearance="brand" />
        </div>
    );

    return (
        <UFOSegment name="enterprise-page-product-navigation">
            <ProductPageSubNav
                productLogoUrl={useLocalizedHref("/enterprise")}
                productLogo={<EnterpriseLogo />}
                productLogoAriaLabel={intl.formatMessage({
                    id: "EnterpriseLandingPage.logo-label",
                    defaultMessage: "Enterprise logo"
                })}
                mobileLogo={<EnterpriseLogo />}
                productPageNavLinks={links}
                mobileLinksSections={[
                    {
                        key: "mobile-enterprise",
                        mobileLinksProps: links
                    }
                ]}
                navigationTrynowCtaText={ctaButtonText}
                navigationTrynowCtaUrl={useLocalizedHref(
                    "/enterprise/contact?formType=product-features"
                )}
                mobileCtaText={mobileCtaButtonText}
                mobileCtaUrl={useLocalizedHref(
                    "/enterprise/contact?formType=product-features"
                )}
            />
        </UFOSegment>
    );
};
